function mulberry32(a) {
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    var t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function simOneGame(
  lH,
  lA,
  r,
  seed,
  isKnockout = false,
  penRateHome,
  penRateAway
) {
  if (!(r > 0)) throw new Error("remisFactor muss > 0 sein.");

  var rng = typeof seed === "number" ? mulberry32(seed | 0) : Math.random;

  var knockout = !!isKnockout;

  var defaultPenaltyConversion = 0.75;

  var penH =
    typeof penRateHome === "number"
      ? penRateHome
      : defaultPenaltyConversion;

  var penA =
    typeof penRateAway === "number"
      ? penRateAway
      : defaultPenaltyConversion;

  var pH = lH / 90;
  var pA = lA / 90;

  var gh = 0;
  var ga = 0;
  var ghHT = 0;
  var gaHT = 0;

  var goalEvents = [];

  function addGoalEvent(minute, side, phase) {
    goalEvents.push({
      minute: minute,
      side: side,
      phase: phase,
      home: gh,
      away: ga,
      score: gh + ":" + ga,
    });
  }

  for (var m = 0; m < 90; m++) {
    var minute = m + 1;
    var factor = gh === ga ? r : 1 / r;

    if (m % 2 === 0) {
      if (rng() < pH * factor) {
        gh++;
        addGoalEvent(minute, "home", "90");
      } else if (rng() < pA * factor) {
        ga++;
        addGoalEvent(minute, "away", "90");
      }
    } else {
      if (rng() < pA * factor) {
        ga++;
        addGoalEvent(minute, "away", "90");
      } else if (rng() < pH * factor) {
        gh++;
        addGoalEvent(minute, "home", "90");
      }
    }

    if (m === 44) {
      ghHT = gh;
      gaHT = ga;
    }
  }

  var ghET = 0;
  var gaET = 0;
  var homePens = 0;
  var awayPens = 0;
  var decidedAfter = "90";
  var outcome = gh > ga ? "1" : gh < ga ? "2" : "X";
  var winner = outcome === "1" ? 1 : outcome === "2" ? 2 : null;

  if (knockout && gh === ga) {
    for (var em = 0; em < 30; em++) {
      var minuteET = 91 + em;
      var etHome = gh + ghET;
      var etAway = ga + gaET;
      var factorET = etHome === etAway ? r : 1 / r;

      if (em % 2 === 0) {
        if (rng() < pH * factorET) {
          ghET++;
          gh++;
          addGoalEvent(minuteET, "home", "ET");
        } else if (rng() < pA * factorET) {
          gaET++;
          ga++;
          addGoalEvent(minuteET, "away", "ET");
        }
      } else {
        if (rng() < pA * factorET) {
          gaET++;
          ga++;
          addGoalEvent(minuteET, "away", "ET");
        } else if (rng() < pH * factorET) {
          ghET++;
          gh++;
          addGoalEvent(minuteET, "home", "ET");
        }
      }
    }

    if (gh !== ga) {
      outcome = gh > ga ? "1" : "2";
      winner = outcome === "1" ? 1 : 2;
      decidedAfter = "N.VERL";
    } else {
      var takenH = 0;
      var takenA = 0;

      while (takenH < 5 || takenA < 5) {
        if (takenH < 5) {
          takenH++;
          if (rng() < penH) homePens++;
        }

        if (takenA < 5) {
          takenA++;
          if (rng() < penA) awayPens++;
        }

        var remainingH = 5 - takenH;
        var remainingA = 5 - takenA;

        if (homePens > awayPens + remainingA) break;
        if (awayPens > homePens + remainingH) break;
      }

      while (homePens === awayPens) {
        if (rng() < penH) homePens++;
        if (rng() < penA) awayPens++;
      }

      winner = homePens > awayPens ? 1 : 2;
      outcome = winner === 1 ? "1" : "2";
      decidedAfter = "N.ELFM";
    }
  }

  return {
    home: gh,
    away: ga,
    ht: { home: ghHT, away: gaHT },
    et: { home: ghET, away: gaET },
    pens: { home: homePens, away: awayPens },
    outcome: outcome,
    winner: winner,
    decidedAfter: decidedAfter,
    goalEvents: goalEvents,
  };
}

/***** Simulation mit Aggregaten für alle Märkte *****/
export function simAllAggregates(lH, lA, r, sims, seed) {
  if (!(r > 0)) throw new Error("remisFactor muss > 0 sein.");

  var rng = typeof seed === "number" ? mulberry32(seed | 0) : Math.random;
  var pH = lH / 90;
  var pA = lA / 90;

  var maxExactGoals = 20;
  var countsExact = Array.from({ length: maxExactGoals + 1 }, () =>
    Array(maxExactGoals + 1).fill(0),
  );

  var totalMax = 40;
  var countsTot = Array(totalMax + 1).fill(0);
  var totMore = 0;

  var htft = Array.from({ length: 3 }, () => Array(3).fill(0));

  var homeWins = 0;
  var draws = 0;
  var awayWins = 0;
  var marketCounters = createMarketCounters();

  var sumH = 0;
  var sumA = 0;

  for (var s = 0; s < sims; s++) {
    var gh = 0;
    var ga = 0;
    var ghHT = 0;
    var gaHT = 0;
    var firstGoalSide = null;
    var firstGoalMinute = null;

    var homeTrailed = false;
    var awayTrailed = false;
    var homeLedAfterTrailing = false;
    var awayLedAfterTrailing = false;

    for (var m = 0; m < 90; m++) {
      var factor = gh === ga ? r : 1 / r;

      var pMinuteH = pH * factor;
      var pMinuteA = pA * factor;

      if (pMinuteH > 1) pMinuteH = 1;
      if (pMinuteA > 1) pMinuteA = 1;
      if (pMinuteH < 0) pMinuteH = 0;
      if (pMinuteA < 0) pMinuteA = 0;

      if (rng() < pMinuteH) {
        gh++;
        if (firstGoalSide === null) {
          firstGoalSide = "home";
          firstGoalMinute = m + 1;
        }
      }

      if (rng() < pMinuteA) {
        ga++;
        if (firstGoalSide === null) {
          firstGoalSide = "away";
          firstGoalMinute = m + 1;
        }
      }

      if (gh < ga) homeTrailed = true;
      if (ga < gh) awayTrailed = true;

      if (homeTrailed && gh > ga) homeLedAfterTrailing = true;
      if (awayTrailed && ga > gh) awayLedAfterTrailing = true;

      if (m === 44) {
        ghHT = gh;
        gaHT = ga;
      }
    }

    sumH += gh;
    sumA += ga;

    if (gh > ga) homeWins++;
    else if (gh === ga) draws++;
    else awayWins++;

    if (gh <= maxExactGoals && ga <= maxExactGoals) {
      countsExact[gh][ga]++;
    }

    var t = gh + ga;
    if (t <= totalMax) countsTot[t]++;
    else totMore++;

    var ht = ghHT > gaHT ? 0 : ghHT < gaHT ? 2 : 1;
    var ft = gh > ga ? 0 : gh < ga ? 2 : 1;
    htft[ht][ft]++;

    recordMarketCounts(
      marketCounters,
      gh,
      ga,
      ghHT,
      gaHT,
      firstGoalSide,
      firstGoalMinute,
      homeTrailed,
      awayTrailed,
      homeLedAfterTrailing,
      awayLedAfterTrailing,
    );
  }

  var simsF = 1 / sims;

  var probsExact = countsExact.map((row) => row.map((c) => c * simsF));
  var coverage = probsExact.reduce(
    (a, row) => a + row.reduce((x, y) => x + y, 0),
    0,
  );
  var anyOtherProb = 1 - coverage;

  var p1 = homeWins * simsF;
  var pX = draws * simsF;
  var p2 = awayWins * simsF;

  var probsTot = countsTot.map((c) => c * simsF);
  var probTotMore = totMore * simsF;

  var htftProbs = Array.from({ length: 3 }, () => Array(3).fill(0));
  for (var h = 0; h < 3; h++) {
    for (var f = 0; f < 3; f++) {
      htftProbs[h][f] = htft[h][f] * simsF;
    }
  }

  var markets = finalizeMarketCounters(marketCounters);

  return {
    mean_home: sumH * simsF,
    mean_away: sumA * simsF,
    mean_total: (sumH + sumA) * simsF,

    matrix10: probsExact.slice(0, 11).map((row) => row.slice(0, 11)),
    matrix20: probsExact,
    coverage: coverage,
    anyOtherProb: anyOtherProb,

    matrix6: probsExact.slice(0, 6).map((row) => row.slice(0, 6)),

    p1: p1,
    pX: pX,
    p2: p2,

    totals: {
      probs: probsTot,
      probMore: probTotMore,
      max: totalMax,
    },

    htft: htftProbs,
    markets: markets,
  };
}

function calculateModelParams(teamsData) {
  if (!Array.isArray(teamsData) || teamsData.length === 0) {
    throw new Error("teamsData muss ein nicht-leeres Array sein.");
  }

  let sumForHome = 0;
  let sumForAway = 0;
  let sumDrawHome = 0;
  let sumDrawAway = 0;

  for (const team of teamsData) {
    sumForHome += Number(team.forHome || 0);
    sumForAway += Number(team.forAway || 0);
    sumDrawHome += Number(team.drawFactorHome || 0);
    sumDrawAway += Number(team.drawFactorAway || 0);
  }

  const n = teamsData.length;

  return {
    avgHomeGoals: sumForHome / n,
    avgAwayGoals: sumForAway / n,
    avgDrawFactor: (sumDrawHome + sumDrawAway) / (2 * n),
  };
}

function createMarketCounters() {
  return {
    n: 0,
    home: 0,
    draw: 0,
    away: 0,
    bttsYes: 0,

    firstGoal: {
      home: 0,
      away: 0,
      none: 0,
      before15: 0,
      before30: 0,
      before45: 0,
      before60: 0,
      after30OrNone: 0,
      firstHalfYes: 0,
      minuteSum: 0,
      minuteCount: 0,
      minuteBuckets: {},
    },

    correctScore: {},
    htCorrectScore: {},

    totalGoals: {},
    goalDiff: {},

    htft: {},
    htGoals: {},
    shGoals: {},

    teamGoalsHome: {},
    teamGoalsAway: {},

    highestScoringHalf: {
      firstHalf: 0,
      secondHalf: 0,
      tie: 0,
    },

    winFromBehind: {
      home: 0,
      away: 0,
      any: 0,
      homeTrailed: 0,
      awayTrailed: 0,
      homeLedAfterTrailing: 0,
      awayLedAfterTrailing: 0,
    },

    winningMargin: {
      homeBy1: 0,
      homeBy2: 0,
      homeBy3Plus: 0,
      awayBy1: 0,
      awayBy2: 0,
      awayBy3Plus: 0,
      draw: 0,
    },

    winToNil: {
      home: 0,
      away: 0,
    },

    cleanSheet: {
      home: 0,
      away: 0,
      both: 0,
      none: 0,
    },

    scoreBothHalves: {
      home: 0,
      away: 0,
      both: 0,
      neither: 0,
    },

    winEitherHalf: {
      home: 0,
      away: 0,
    },

    winBothHalves: {
      home: 0,
      away: 0,
    },

    combos: {
      homeAndOver25: 0,
      drawAndOver25: 0,
      awayAndOver25: 0,
      homeAndUnder25: 0,
      drawAndUnder25: 0,
      awayAndUnder25: 0,
      homeAndBtts: 0,
      drawAndBtts: 0,
      awayAndBtts: 0,
      homeWinOver25: 0,
      drawUnder25: 0,
      awayWinBTTS: 0,
    },
  };
}

function incrementMap(map, key) {
  const k = String(key);
  map[k] = (map[k] || 0) + 1;
}

function recordMarketCounts(
  c,
  hg,
  ag,
  hgh,
  agh,
  firstGoalSide,
  firstGoalMinute,
  homeTrailed,
  awayTrailed,
  homeLedAfterTrailing,
  awayLedAfterTrailing,
) {
  c.n++;

  const homeWin = hg > ag;
  const draw = hg === ag;
  const awayWin = hg < ag;
  const btts = hg > 0 && ag > 0;
  const tg = hg + ag;
  const htg = hgh + agh;
  const shg = tg - htg;
  const gd = hg - ag;

  const homeSecondHalfGoals = hg - hgh;
  const awaySecondHalfGoals = ag - agh;

  const homeWonFirstHalf = hgh > agh;
  const awayWonFirstHalf = agh > hgh;
  const homeWonSecondHalf = homeSecondHalfGoals > awaySecondHalfGoals;
  const awayWonSecondHalf = awaySecondHalfGoals > homeSecondHalfGoals;

  if (homeWin) c.home++;
  else if (draw) c.draw++;
  else c.away++;

  if (btts) c.bttsYes++;

  if (firstGoalSide === "home") c.firstGoal.home++;
  else if (firstGoalSide === "away") c.firstGoal.away++;
  else c.firstGoal.none++;

  if (Number.isFinite(Number(firstGoalMinute))) {
    var fgMinute = Number(firstGoalMinute);
    c.firstGoal.minuteSum += fgMinute;
    c.firstGoal.minuteCount++;
    incrementMap(c.firstGoal.minuteBuckets, fgMinute);

    if (fgMinute < 15.5) c.firstGoal.before15++;
    if (fgMinute < 30.5) c.firstGoal.before30++;
    else c.firstGoal.after30OrNone++;

    if (fgMinute < 45.5) {
      c.firstGoal.before45++;
      c.firstGoal.firstHalfYes++;
    }

    if (fgMinute < 60.5) c.firstGoal.before60++;
  } else {
    c.firstGoal.after30OrNone++;
  }

  incrementMap(c.correctScore, hg + ":" + ag);
  incrementMap(c.htCorrectScore, hgh + ":" + agh);

  incrementMap(c.totalGoals, tg);
  incrementMap(c.goalDiff, gd);
  incrementMap(c.htGoals, htg);
  incrementMap(c.shGoals, shg);
  incrementMap(c.teamGoalsHome, hg);
  incrementMap(c.teamGoalsAway, ag);

  const htRes = hgh > agh ? "1" : hgh === agh ? "X" : "2";
  const ftRes = homeWin ? "1" : draw ? "X" : "2";
  incrementMap(c.htft, htRes + "/" + ftRes);

  if (htg > shg) c.highestScoringHalf.firstHalf++;
  else if (shg > htg) c.highestScoringHalf.secondHalf++;
  else c.highestScoringHalf.tie++;

  if (homeTrailed) c.winFromBehind.homeTrailed++;
  if (awayTrailed) c.winFromBehind.awayTrailed++;
  if (homeLedAfterTrailing) c.winFromBehind.homeLedAfterTrailing++;
  if (awayLedAfterTrailing) c.winFromBehind.awayLedAfterTrailing++;

  if (homeWin && homeTrailed) {
    c.winFromBehind.home++;
    c.winFromBehind.any++;
  }

  if (awayWin && awayTrailed) {
    c.winFromBehind.away++;
    c.winFromBehind.any++;
  }

  if (draw) c.winningMargin.draw++;
  else if (gd === 1) c.winningMargin.homeBy1++;
  else if (gd === 2) c.winningMargin.homeBy2++;
  else if (gd >= 3) c.winningMargin.homeBy3Plus++;
  else if (gd === -1) c.winningMargin.awayBy1++;
  else if (gd === -2) c.winningMargin.awayBy2++;
  else if (gd <= -3) c.winningMargin.awayBy3Plus++;

  if (homeWin && ag === 0) c.winToNil.home++;
  if (awayWin && hg === 0) c.winToNil.away++;

  const homeCleanSheet = ag === 0;
  const awayCleanSheet = hg === 0;

  if (homeCleanSheet && awayCleanSheet) c.cleanSheet.both++;
  else if (homeCleanSheet) c.cleanSheet.home++;
  else if (awayCleanSheet) c.cleanSheet.away++;
  else c.cleanSheet.none++;

  const homeScoredFirstHalf = hgh > 0;
  const homeScoredSecondHalf = homeSecondHalfGoals > 0;
  const awayScoredFirstHalf = agh > 0;
  const awayScoredSecondHalf = awaySecondHalfGoals > 0;

  const homeScoredBothHalves = homeScoredFirstHalf && homeScoredSecondHalf;
  const awayScoredBothHalves = awayScoredFirstHalf && awayScoredSecondHalf;

  if (homeScoredBothHalves) c.scoreBothHalves.home++;
  if (awayScoredBothHalves) c.scoreBothHalves.away++;
  if (homeScoredBothHalves && awayScoredBothHalves) c.scoreBothHalves.both++;
  if (!homeScoredBothHalves && !awayScoredBothHalves)
    c.scoreBothHalves.neither++;

  if (homeWonFirstHalf || homeWonSecondHalf) c.winEitherHalf.home++;
  if (awayWonFirstHalf || awayWonSecondHalf) c.winEitherHalf.away++;

  if (homeWonFirstHalf && homeWonSecondHalf) c.winBothHalves.home++;
  if (awayWonFirstHalf && awayWonSecondHalf) c.winBothHalves.away++;

  const over25 = tg >= 3;
  const under25 = tg <= 2;

  if (homeWin && over25) c.combos.homeAndOver25++;
  if (draw && over25) c.combos.drawAndOver25++;
  if (awayWin && over25) c.combos.awayAndOver25++;

  if (homeWin && under25) c.combos.homeAndUnder25++;
  if (draw && under25) c.combos.drawAndUnder25++;
  if (awayWin && under25) c.combos.awayAndUnder25++;

  if (homeWin && btts) c.combos.homeAndBtts++;
  if (draw && btts) c.combos.drawAndBtts++;
  if (awayWin && btts) c.combos.awayAndBtts++;

  if (homeWin && over25) c.combos.homeWinOver25++;
  if (draw && under25) c.combos.drawUnder25++;
  if (awayWin && btts) c.combos.awayWinBTTS++;
}

function probabilityMap(countMap, n) {
  const result = {};
  Object.keys(countMap || {}).forEach((key) => {
    result[key] = countMap[key] / n;
  });
  return result;
}

function fairItem(probability) {
  const p = Number(probability || 0);
  return {
    probability: p,
    fairQuote: p > 0 ? 1 / p : null,
  };
}

function fairMapFromCounters(counterObj, n) {
  const result = {};
  Object.keys(counterObj || {}).forEach((key) => {
    result[key] = fairItem(Number(counterObj[key] || 0) / n);
  });
  return result;
}

function asianTruePriceFromParts(pWin, pHalfWin, pPari, pHalfLoss) {
  const denominator = pWin + 0.5 * pHalfWin;
  if (!(denominator > 0)) return null;
  return (1 - 0.5 * pHalfLoss - 0.5 * pHalfWin - pPari) / denominator;
}

function settleSingleAsian(value, line, direction) {
  const diff =
    direction === "over" || direction === "home" ? value - line : line - value;

  if (diff > 0) return 1;
  if (diff === 0) return 0;
  return -1;
}

function asianComponentLines(line) {
  const rounded = Math.round(Number(line) * 4) / 4;
  const whole = Math.floor(rounded);
  const frac = Math.round((rounded - whole) * 4);

  if (frac === 1) return [whole, whole + 0.5];
  if (frac === 3) return [whole + 0.5, whole + 1];
  return [rounded, rounded];
}

function asianMarketFromDistribution(countMap, n, line, direction) {
  let pWin = 0;
  let pHalfWin = 0;
  let pPari = 0;
  let pHalfLoss = 0;
  let pLoss = 0;

  const [lineA, lineB] = asianComponentLines(line);

  Object.keys(countMap || {}).forEach((key) => {
    const value = Number(key);
    const probability = countMap[key] / n;
    const s1 = settleSingleAsian(value, lineA, direction);
    const s2 = settleSingleAsian(value, lineB, direction);
    const settlement = (s1 + s2) / 2;

    if (settlement === 1) pWin += probability;
    else if (settlement === 0.5) pHalfWin += probability;
    else if (settlement === 0) pPari += probability;
    else if (settlement === -0.5) pHalfLoss += probability;
    else pLoss += probability;
  });

  const fairQuote = asianTruePriceFromParts(pWin, pHalfWin, pPari, pHalfLoss);

  return {
    probabilityEquivalent: fairQuote && fairQuote > 0 ? 1 / fairQuote : null,
    fairQuote,
    pWin,
    pHalfWin,
    pPari,
    pHalfLoss,
    pLoss,
  };
}

function sumProbByPredicate(probMap, predicate) {
  let sum = 0;
  Object.keys(probMap || {}).forEach((key) => {
    if (predicate(Number(key))) sum += probMap[key];
  });
  return sum;
}

function buildDisplayCorrectScores(correctScoreProb, maxDisplayGoals) {
  const result = {};
  const maxGoals =
    Number.isFinite(Number(maxDisplayGoals)) && Number(maxDisplayGoals) >= 0
      ? Number(maxDisplayGoals)
      : 5;

  let covered = 0;

  for (let h = 0; h <= maxGoals; h++) {
    for (let a = 0; a <= maxGoals; a++) {
      const key = h + ":" + a;
      const probability = Number(correctScoreProb[key] || 0);
      result[key] = fairItem(probability);
      covered += probability;
    }
  }

  result.anyOther = fairItem(Math.max(0, 1 - covered));
  return result;
}

function finalizeMarketCounters(c) {
  const n = c.n || 1;
  const p = (x) => Number(x || 0) / n;

  const correctScoreProb = probabilityMap(c.correctScore, n);
  const htCorrectScoreProb = probabilityMap(c.htCorrectScore, n);

  const totalGoalsProb = probabilityMap(c.totalGoals, n);
  const goalDiffProb = probabilityMap(c.goalDiff, n);
  const htftSlashProb = probabilityMap(c.htft, n);
  const htGoalsProb = probabilityMap(c.htGoals, n);
  const shGoalsProb = probabilityMap(c.shGoals, n);
  const teamGoalsHomeProb = probabilityMap(c.teamGoalsHome, n);
  const teamGoalsAwayProb = probabilityMap(c.teamGoalsAway, n);

  const htft = {};
  Object.keys(htftSlashProb).forEach((key) => {
    const compactKey = key.replace("/", "");
    htft[key] = fairItem(htftSlashProb[key]);
    htft[compactKey] = fairItem(htftSlashProb[key]);
  });

  const asianGoalLineNumbers = [
    0.5, 1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3, 3.25, 3.5, 3.75, 4, 4.25,
    4.5, 4.75, 5, 5.5,
  ];

  const asianGoalLines = asianGoalLineNumbers.map((line) => ({
    line,
    over: asianMarketFromDistribution(c.totalGoals, n, line, "over"),
    under: asianMarketFromDistribution(c.totalGoals, n, line, "under"),
  }));

  const handicapNumbers = [
    -2, -1.75, -1.5, -1.25, -1, -0.75, -0.5, -0.25, 0, 0.25, 0.5, 0.75, 1, 1.25,
    1.5, 1.75, 2,
  ];

  const asianHandicaps = handicapNumbers.map((line) => ({
    line,
    home: asianMarketFromDistribution(c.goalDiff, n, -line, "home"),
    away: asianMarketFromDistribution(c.goalDiff, n, -line, "under"),
  }));

  const totalGoals = {
    distribution: totalGoalsProb,

    over05: fairItem(sumProbByPredicate(totalGoalsProb, (x) => x >= 1)),
    under05: fairItem(sumProbByPredicate(totalGoalsProb, (x) => x <= 0)),

    over15: fairItem(sumProbByPredicate(totalGoalsProb, (x) => x >= 2)),
    under15: fairItem(sumProbByPredicate(totalGoalsProb, (x) => x <= 1)),

    over25: fairItem(sumProbByPredicate(totalGoalsProb, (x) => x >= 3)),
    under25: fairItem(sumProbByPredicate(totalGoalsProb, (x) => x <= 2)),

    over35: fairItem(sumProbByPredicate(totalGoalsProb, (x) => x >= 4)),
    under35: fairItem(sumProbByPredicate(totalGoalsProb, (x) => x <= 3)),

    over45: fairItem(sumProbByPredicate(totalGoalsProb, (x) => x >= 5)),
    under45: fairItem(sumProbByPredicate(totalGoalsProb, (x) => x <= 4)),

    over55: fairItem(sumProbByPredicate(totalGoalsProb, (x) => x >= 6)),
    under55: fairItem(sumProbByPredicate(totalGoalsProb, (x) => x <= 5)),
  };

  const goalDiff = {
    distribution: goalDiffProb,
    homeBy1: fairItem(goalDiffProb["1"] || 0),
    homeBy2: fairItem(goalDiffProb["2"] || 0),
    homeBy3Plus: fairItem(sumProbByPredicate(goalDiffProb, (x) => x >= 3)),
    homeBy2Plus: fairItem(sumProbByPredicate(goalDiffProb, (x) => x >= 2)),
    awayBy1: fairItem(goalDiffProb["-1"] || 0),
    awayBy2: fairItem(goalDiffProb["-2"] || 0),
    awayBy3Plus: fairItem(sumProbByPredicate(goalDiffProb, (x) => x <= -3)),
    awayBy2Plus: fairItem(sumProbByPredicate(goalDiffProb, (x) => x <= -2)),
  };

  const combos = {};
  Object.keys(c.combos || {}).forEach((key) => {
    combos[key] = fairItem(p(c.combos[key]));
  });

  const firstGoalMinuteDistribution = probabilityMap(
    c.firstGoal.minuteBuckets,
    n,
  );

  const firstGoalAverageMinute =
    c.firstGoal.minuteCount > 0
      ? c.firstGoal.minuteSum / c.firstGoal.minuteCount
      : null;

  return {
    sims: c.n,

    rawCounts: {
      correctScore: c.correctScore,
      htCorrectScore: c.htCorrectScore,
      totalGoals: c.totalGoals,
      goalDiff: c.goalDiff,
      htft: c.htft,
      htGoals: c.htGoals,
      shGoals: c.shGoals,
      teamGoalsHome: c.teamGoalsHome,
      teamGoalsAway: c.teamGoalsAway,
      firstGoal: c.firstGoal,
      highestScoringHalf: c.highestScoringHalf,
      winFromBehind: c.winFromBehind,
      winningMargin: c.winningMargin,
      winToNil: c.winToNil,
      cleanSheet: c.cleanSheet,
      scoreBothHalves: c.scoreBothHalves,
      winEitherHalf: c.winEitherHalf,
      winBothHalves: c.winBothHalves,
    },

    oneXTwo: {
      home: fairItem(p(c.home)),
      draw: fairItem(p(c.draw)),
      away: fairItem(p(c.away)),
      1: fairItem(p(c.home)),
      X: fairItem(p(c.draw)),
      2: fairItem(p(c.away)),
    },

    btts: {
      yes: fairItem(p(c.bttsYes)),
      no: fairItem(1 - p(c.bttsYes)),
    },

    firstGoal: {
      home: fairItem(p(c.firstGoal.home)),
      away: fairItem(p(c.firstGoal.away)),
      none: fairItem(p(c.firstGoal.none)),

      before15: fairItem(p(c.firstGoal.before15)),
      before30: fairItem(p(c.firstGoal.before30)),
      after30OrNone: fairItem(p(c.firstGoal.after30OrNone)),

      before45: fairItem(p(c.firstGoal.before45)),
      before60: fairItem(p(c.firstGoal.before60)),

      firstHalfYes: fairItem(p(c.firstGoal.firstHalfYes)),
      firstHalfNo: fairItem(1 - p(c.firstGoal.firstHalfYes)),

      averageMinute: firstGoalAverageMinute,
      minuteDistribution: firstGoalMinuteDistribution,
    },

    correctScore: correctScoreProb,
    displayCorrectScores: buildDisplayCorrectScores(correctScoreProb, 5),
    displayCorrectScores4: buildDisplayCorrectScores(correctScoreProb, 4),
    displayCorrectScores5: buildDisplayCorrectScores(correctScoreProb, 5),

    htCorrectScore: htCorrectScoreProb,
    displayHtCorrectScores: buildDisplayCorrectScores(htCorrectScoreProb, 4),
    displayHtCorrectScores3: buildDisplayCorrectScores(htCorrectScoreProb, 3),
    displayHtCorrectScores4: buildDisplayCorrectScores(htCorrectScoreProb, 4),

    totalGoals,
    goalDiff,
    asianGoalLines,
    asianHandicaps,
    htft,
    htGoals: htGoalsProb,
    shGoals: shGoalsProb,

    teamGoals: {
      home: teamGoalsHomeProb,
      away: teamGoalsAwayProb,
    },

    highestScoringHalf: fairMapFromCounters(c.highestScoringHalf, n),
    winFromBehind: fairMapFromCounters(c.winFromBehind, n),
    winningMargin: fairMapFromCounters(c.winningMargin, n),
    winToNil: fairMapFromCounters(c.winToNil, n),
    cleanSheet: fairMapFromCounters(c.cleanSheet, n),
    scoreBothHalves: fairMapFromCounters(c.scoreBothHalves, n),
    winEitherHalf: fairMapFromCounters(c.winEitherHalf, n),
    winBothHalves: fairMapFromCounters(c.winBothHalves, n),

    matchCombos: combos,
    combos,
  };
}

if (
  typeof window !== "undefined"
) {
  window.createMarketCounters =
    createMarketCounters;

  window.recordMarketCounts =
    recordMarketCounts;

  window.finalizeMarketCounters =
    finalizeMarketCounters;
}
